import type { MessageKey } from '@/i18n';
import type { HubGame } from '@/types';

export interface LiveFamily {
  id: string;
  key: MessageKey;
  art: string;
  active: boolean;
}

export const LIVE_FAMILIES: LiveFamily[] = [
  { id: 'roulette', key: 'liveFamily.roulette', art: '/live-cards/royal-roulette.png', active: true },
  { id: 'blackjack', key: 'liveFamily.blackjack', art: '/live-cards/royal-blackjack.png', active: true },
  { id: 'auto-roulette', key: 'liveFamily.autoRoulette', art: '/live-cards/auto-roulette.png', active: false },
  { id: 'thunder-roulette', key: 'liveFamily.thunderRoulette', art: '/live-cards/thunder-roulette.png', active: false },
  { id: 'infinity-blackjack', key: 'liveFamily.infinityBlackjack', art: '/live-cards/infinity-blackjack.png', active: false },
  { id: 'baccarat', key: 'liveFamily.baccarat', art: '/live-cards/baccarat.png', active: false },
  { id: 'poker', key: 'liveFamily.poker', art: '/live-cards/poker.png', active: false },
  { id: 'dice', key: 'liveFamily.dice', art: '/live-cards/dice.png', active: false },
  { id: 'show-games', key: 'liveFamily.showGames', art: '/live-cards/show-games.png', active: false },
];

function haystack(game: HubGame): string {
  return [game.id, game.title, game.details?.gameType, game.details?.tableName, ...(game.tags ?? [])]
    .filter(Boolean)
    .join(' ')
    .toLowerCase();
}

function matches(game: HubGame, familyId: string): boolean {
  const text = haystack(game);
  switch (familyId) {
    case 'roulette':
      return /roulette/.test(text) && !/auto|thunder/.test(text);
    case 'blackjack':
      return /blackjack/.test(text) && !/infinity/.test(text);
    case 'auto-roulette':
      return /auto/.test(text) && /roulette/.test(text);
    case 'thunder-roulette':
      return /thunder/.test(text) && /roulette/.test(text);
    case 'infinity-blackjack':
      return /infinity/.test(text) && /blackjack/.test(text);
    case 'baccarat':
      return /baccarat/.test(text);
    case 'poker':
      return /poker/.test(text);
    case 'dice':
      return /dice/.test(text);
    case 'show-games':
      return /show|cabaret/.test(text);
    default:
      return false;
  }
}

/**
 * A family card opens one playable table rather than a sub-listing, so the
 * first catalog match is the card's destination.
 */
export function familyGameId(games: HubGame[], familyId: string): string | null {
  const hit = games.find((game) => matches(game, familyId));
  return hit?.id ?? null;
}
